<template>
  <v-container fluid class="mt-5">
    <div class="divider my-5"></div>
    <v-layout row wrap>
      <Feature v-for="(feature,index) in features" :key="index" :feature="feature"></Feature>
    </v-layout>
  </v-container>
</template>

<script>
  import Feature from '../Feature';

  export default {
    name: 'DriverFeatures',
    components: {
      Feature,
    },
    data() {
      return {
        features: [
          {
            image: '../../../static/contact-us/feature-1.svg',
            title: this.$t('report an incident'),
            text: this.$t('report an incident text'),
          },
          {
            image: '../../../static/contact-us/feature-2.svg',
            title: this.$t('lost an item'),
            text: this.$t('lost an item text'),
          },
          {
            image: '../../../static/contact-us/feature-3.svg',
            title: this.$t('constant support'),
            text: this.$t('constant support text'),
          },
        ],
      };
    },
  };
</script>

<style lang="scss" scoped>
.divider{
  width: 80%;
  height: 0;
  margin: 0 auto;
}
</style>
